import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getLocalStorage } from "../../utils/localStorage";

/**
 * Uplifted from `hooks/useIsLoggedinStatus.ts` — **byte-identical in both apps** (verified with
 * `diff`), so the body lives here and both variants re-export it (standing rule 4).
 *
 * The apps imported `getLocalStorage` from their own `utils/localStorage`, which is itself a shim
 * over `@rista/core/utils/localStorage`; core imports that folder directly (folder form — the
 * bundler picks browser localStorage on web, MMKV on mobile).
 *
 * ⚠️ `[getLocalStorage("ATOKEN")]` CALLS the function inside the dependency array, so the effect
 * re-runs whenever the stored token's VALUE changes between renders — not on a subscription. It
 * reads oddly and it is what both apps ship; preserved verbatim.
 *
 * ⚠️ Mobile has ZERO importers of this hook today (web has one). It is uplifted anyway because the
 * file exists in both apps — rule 4: uplifting only the asking side leaves two definitions to drift.
 */
export function useIsLoggedinStatus() {
  const isOfflineLogin = useSelector((state: any) => state.globalStore?.isOfflineLogin);

  const [isLoggedin, setIsLoggedin] = useState(true);

  useEffect(() => {
    if (!getLocalStorage("ATOKEN") && !isOfflineLogin){ 
      setIsLoggedin(false);}
    else{
      setIsLoggedin(true);
    }  
  }, [getLocalStorage("ATOKEN")]);
  
  
  return isLoggedin;
}
